import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

//cursor effect
const cursor = document.querySelector('.cursor');

document.addEventListener('mousemove', e => {
  cursor.setAttribute("style", "top: "+(e.pageY + 25)+"px; left: "+(e.pageX + 20)+"px")
})

document.addEventListener('click', e =>{
  cursor.classList.add('expand');

  setTimeout(() => {
    cursor.classList.remove('expand')
  }, 500);
})

//cursor2

const cursor2 = document.querySelector('.cursor2');

document.addEventListener('mousemove', e => {
  cursor2.setAttribute("style", "top: "+(e.pageY+10)+"px; left: "+(e.pageX+10 )+"px")
})

document.addEventListener('click', e =>{
  cursor2.classList.add('expand');

  setTimeout(() => {
    cursor2.classList.remove('expand')
  }, 500);
})

//welcome

let welcome = document.querySelector('.welcome');
let app = document.querySelector('.App');

const welcomeFade = () => {
  setTimeout(() => {
    welcome.remove();
  }, 2600);
}
document.addEventListener('DOMContentLoaded',welcomeFade);

//Welcome svg animation

// let welcomeText = document.querySelector('.svg-path');
// // console.log(welcomeText);

// for(let i = 0; i < welcomeText.length; i++) {
//   console.log(i.getTotalLength())
// }

